import React, { useEffect, useRef } from "react";
import award1 from "../assets/imgs/Awards/Scimit.jpeg";
import award2 from "../assets/imgs/Awards/TechXplore.jpeg";
import award3 from "../assets/imgs/Awards/GenNext.jpeg";
import award4 from "../assets/imgs/Awards/Fruition.jpeg";

const Awards = () => {
  const canvasRef = useRef(null);
  const awardsSectionRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const awardsSection = awardsSectionRef.current;

    let w = 0;
    let h = 0;

    function resizeCanvas() {
      w = canvas.width = awardsSection.offsetWidth;
      h = canvas.height = awardsSection.offsetHeight;
    }
    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();

    const NUM_CONFETTI = 500;
    const COLORS = [
      [85, 71, 106],
      [174, 61, 99],
      [219, 56, 83],
      [244, 92, 68],
      [248, 182, 70],
    ];
    const PI_2 = 2 * Math.PI;

    function range(a, b) {
      return (b - a) * Math.random() + a;
    }

    function drawCircle(x, y, r, style) {
      context.beginPath();
      context.arc(x, y, r, 0, PI_2, false);
      context.fillStyle = style;
      context.fill();
    }

    let xpos = 0.5;
    document.onmousemove = (e) => {
      xpos = e.pageX / w;
    };

    class Confetti {
      constructor() {
        this.style = COLORS[Math.floor(range(0, COLORS.length))];
        this.rgb = `rgba(${this.style[0]},${this.style[1]},${this.style[2]}`;
        this.r = Math.floor(range(2, 6));
        this.r2 = 2 * this.r;
        this.replace();
      }

      replace() {
        this.opacity = 0;
        this.dop = 0.03 * range(1, 4);
        this.x = range(-this.r2, w - this.r2);
        this.y = range(-20, h - this.r2);
        this.xmax = w - this.r;
        this.ymax = h - this.r;
        this.vx = range(0, 2) + 8 * xpos - 5;
        this.vy = 0.7 * this.r + range(-1, 1);
      }

      draw() {
        this.x += this.vx;
        this.y += this.vy;
        this.opacity += this.dop;
        if (this.opacity > 1) {
          this.opacity = 1;
          this.dop *= -1;
        }
        if (this.opacity < 0 || this.y > this.ymax) {
          this.replace();
        }
        if (!(0 < this.x && this.x < this.xmax)) {
          this.x = (this.x + this.xmax) % this.xmax;
        }
        drawCircle(Math.floor(this.x), Math.floor(this.y), this.r, `${this.rgb},${this.opacity})`);
      }
    }

    const confetti = [];
    for (let i = 0; i < NUM_CONFETTI; i++) {
      confetti.push(new Confetti());
    }

    let animationFrameId;
    const render = () => {
      context.clearRect(0, 0, w, h);
      confetti.forEach((c) => c.draw());
      animationFrameId = requestAnimationFrame(render);
    };
    render();

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <section className="awards" id="awards" ref={awardsSectionRef}>
      <canvas id="world" ref={canvasRef}></canvas>
      <div className="title">
        <h1 class="scroll-effect">AWARDS</h1>
      </div>

      <div className="award-collection">
        {[award1, award2, award3, award4].map((award, i) => (
          <div key={i} className="gallery scroll-effect">
            <div>
              <img src={award} alt="" />
              <div className="gradient-blue"></div>
              <h2>
                {i === 0
                  ? "SCIMIT'25"
                  : i === 1
                  ? "TECHXPLORE’25"
                  : i === 2
                  ? "GEN NEXT’25"
                  : "FRUTION’25"}
              </h2>
              <p>
                {i === 0
                  ? "FIRST Prize in Scimit’25 hosted by Manakula Vinayagar Institute Of Technology with cash prize of 7500/-"
                  : i === 1
                  ? "SECOND Prize in TechXplore’25 hosted by Mailam Engineering College with cash prize of 5000/-"
                  : i === 2
                  ? "THIRD Prize in GenNext’25 hosted by IFET Engineering College with cash prize of 10,000/-"
                  : "SPONSOR Prize at Fruition’25 hosted by Manakula Vinayagar Institute Of Technology with cash prize of 10,000/-"}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Awards;
